import React from "react";
import { Grid, Box, Flex } from "styled-system/jsx";
import { Text } from "@ttc3k/trekker";

type TimelineGroupLayoutProps = React.PropsWithChildren & {
  formattedDateString: string;
};

export const TimelineGroupLayout = ({
  formattedDateString,
  children,
}: TimelineGroupLayoutProps) => {
  return (
    <Grid
      gridTemplateColumns="48px 1fr"
      gridGap="150"
      justifyItems="flex-start"
      alignItems="stretch"
      w="full"
    >
      <Flex flexDir="column" alignItems="center" gap="100" w="full">
        <Text visual="smallTag" color="text.light">
          {formattedDateString}
        </Text>
        <Box
          border="1px solid"
          borderColor="border.light"
          borderLeft="none"
          alignSelf="center"
          w="0"
          height="full"
        />
      </Flex>
      <Flex flexDir="column" gap="150" w="full">
        {children}
      </Flex>
    </Grid>
  );
};
